export default "__VITE_ASSET__DKDVqURF__"